<template>
  <div>
    <Errors :errors="errors" />

    <div class="cms-content capped-md">
      <span v-if="currentSite === 'inboedelopslag'">
        Selecteer meubelstukken die uw wilt opslaan om zo tot een berekening te komen van de geschatte benodigde opslagruimte.
      </span>

      <span v-else>
        LET OP! Naast ieder meubelstuk ziet u het de- en montage icoontje <Icon name="wrench" class="icon--sm" />. Als een meubelstuk gedemonteerd moet worden zet dan bij het betreffende meubelstuk deze optie aan! Als u bij wensen heeft aangegeven dat u de- en montagewerkzaamheden door Van Beek wilt laten uitvoeren dan nemen we dit voor deze meubelstukken gelijk mee in de aanbieding.
      </span>
    </div>

    <div class="row row--tight-gutters mt-3 mt-lg-4">
      <div class="col-lg-4 d-flex flex-column">
        <div class="intake__heading mb-2">
          1. Selecteer een kamer
        </div>

        <IntakeSidebar />
      </div>

      <div class="col-lg-8 d-flex flex-column mt-3 mt-lg-0">
        <div class="intake__heading mb-2">
          2. Selecteer items om op te slaan
        </div>

        <IntakeContent />
      </div>
    </div>

    <button
      type="button"
      class="btn btn--primary mt-3"
      @click="() => setActiveTab(currentSite === 'inboedelopslag' ? 'client': 'addition')"
    >
      Volgende stap
    </button>

    <a
      v-if="currentSite === 'inboedelopslag'"
      class="btn btn--primary mt-3"
      :href="`${reserveContainerPage}?cubic_metres=${totalCubicMetres}`"
    >
      Reserveer ruimte
    </a>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Errors from '@/intake/components/Errors.vue';
import Icon from '@/intake/components/Icon.vue';
import IntakeSidebar from '@/intake/components/IntakeSidebar.vue';
import IntakeContent from '@/intake/components/IntakeContent.vue';

export default {
  components: {
    Errors,
    Icon,
    IntakeSidebar,
    IntakeContent,
  },

  computed: {
    ...mapGetters({
      errors: 'roomErrors',
      currentSite: 'currentSite',
      reserveContainerPage: 'reserveContainerPage',
      totalCubicMetres: 'room/totalCubicMetres',
    }),
  },

  methods: {
    ...mapMutations({
      setActiveTab: 'setActiveTab',
    }),
  },
};
</script>
